@if (fieldNote) {
  <div class="text-center">
    <div class="container-fluid field-note ">
      <div class="field-note-title">
        {{date | date:medium}}
      </div>
      <div>
        <img class="weather-icon" [src]="fieldNote.weatherIconUrl" alt=""/>
      </div>
      <hr />
      <div>
        <div class="container-fluid field-note-content">
          {{fieldNote.text}}
        </div>
        <div class="container-fluid field-note-footer">
          <span>—</span>{{fieldNote.author}}<span>—</span>
        </div>
      </div>
    </div>
  </div>
}
